import { create } from "zustand";
import { persist } from 'zustand/middleware';

type UiState = {
  headerTitle: string;
  reviewTaskId: string | null;
  showCompletedTasks: boolean;
  isSidebarOpen: boolean;
  pasteTrigger: number;
  pasteData?: string;
  isFileExplorerSearchVisible: boolean;
  isGitPanelVisible: boolean;
  isCommandPaletteOpen: boolean;
  isInteractiveGeneration: boolean;
};

type UiActions = {
  setHeaderTitle: (title: string) => void;
  setReviewTaskId: (taskId: string | null) => void;
  setShowCompletedTasks: (show: boolean) => void;
  triggerPaste: (data: string) => void;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  setIsFileExplorerSearchVisible: (visible: boolean) => void;
  setIsGitPanelVisible: (visible: boolean) => void;
  setIsCommandPaletteOpen: (open: boolean) => void;
  setIsInteractiveGeneration: (interactive: boolean) => void;
  reset: () => void;
};

const initialState: UiState = {
  headerTitle: "",
  reviewTaskId: null,
  showCompletedTasks: false,
  isSidebarOpen: false,
  pasteTrigger: 0,
  isInteractiveGeneration: false,
  pasteData: undefined,
  isFileExplorerSearchVisible: false,
  isGitPanelVisible: false,
  isCommandPaletteOpen: false,
};

export const useUiStore = create<UiState & UiActions>()(
  persist(
    (set) => ({
      ...initialState,
      setHeaderTitle: (title) => set({ headerTitle: title }),
      setReviewTaskId: (taskId) => set({ reviewTaskId: taskId }),
      reset: () => set(initialState),
      setShowCompletedTasks: (show) => set({ showCompletedTasks: show }),
      triggerPaste: (data) => set((state) => ({ pasteTrigger: state.pasteTrigger + 1, pasteData: data })),
      toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
      closeSidebar: () => set({ isSidebarOpen: false }),
      setIsFileExplorerSearchVisible: (visible) => set({ isFileExplorerSearchVisible: visible }),
      setIsGitPanelVisible: (visible) => set({ isGitPanelVisible: visible }),
      setIsCommandPaletteOpen: (open) => set({ isCommandPaletteOpen: open }),
      setIsInteractiveGeneration: (interactive) => set({ isInteractiveGeneration: interactive }),
    }),
    {
      name: 'ui-storage', // name of the item in the storage (must be unique)
      partialize: (state) => ({
        isInteractiveGeneration: state.isInteractiveGeneration, // only persist this key
      }),
    }
  )
);